import React, { useMemo, useState } from "react";
import { Box, CircularProgress, Tab, Tabs } from "@mui/material";
import { useIntl } from "react-intl";
import { withUserContext } from "components/hoc/withUserContext";
import RevaText from "components/common/RevaText";
import EditCompetition from "components/pages/Competition/EditCompetition";
import GestionAdministrators from "components/pages/Gestion/GestionAdministrators";
import CompetitionCustomFields from "components/pages/Competition/CompetitionCustomFields";
import CompetitionScheduling from "components/pages/Competition/CompetitionScheduling";
import GestionVenues from "components/pages/Gestion/GestionVenues";
import GestionMatchSheetSettings from "components/pages/Gestion/GestionMatchSheetSettings";
import { resolveActiveSettingsTab, visibleSettingsTabs } from "components/pages/Gestion/gestion-settings-tabs";
import { useGestionShellCompetition } from "hooks/useGestionShellCompetition";
import { useGestionAccess } from "hooks/useGestionAccess";

const GestionSettings = (props) => {
  const intl = useIntl();
  const { shell, ready } = useGestionShellCompetition();
  const access = useGestionAccess();
  const visibleTabs = useMemo(() => visibleSettingsTabs(access), [access]);
  const [tab, setTab] = useState(null);
  const activeTab = resolveActiveSettingsTab(tab, visibleTabs);

  const match = useMemo(() => {
    if (!shell?.uuid_) return props.match;
    return {
      ...props.match,
      params: { ...props.match.params, id: shell.uuid_ },
    };
  }, [props.match, shell]);

  if (!ready) {
    return (
      <Box display="flex" justifyContent="center" sx={{ py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!shell?.uuid_) {
    return (
      <Box sx={{ p: 3 }}>
        <RevaText>{intl.formatMessage({ id: "gestion.error.generic" })}</RevaText>
      </Box>
    );
  }

  const sectionProps = { ...props, match, hideCompetitionDates: true, competitionUuid: shell.uuid_ };

  return (
    <Box sx={{ width: "100%", p: { xs: 2, md: 3 } }}>
      <RevaText variant="h4" sx={{ mb: 2 }}>
        {intl.formatMessage({ id: "gestion.nav.settings" })}
      </RevaText>
      {visibleTabs.length > 0 ? (
        <Tabs
          value={activeTab ?? false}
          onChange={(_event, next) => setTab(next)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
        >
          {visibleTabs.map((item) => (
            <Tab key={item} value={item} label={intl.formatMessage({ id: `gestion.settings.tab.${item}` })} />
          ))}
        </Tabs>
      ) : null}
      {activeTab === "details" ? <EditCompetition {...sectionProps} gestion onSaved={() => {}} /> : null}
      {activeTab === "managers" ? <GestionAdministrators /> : null}
      {activeTab === "venues" ? <GestionVenues embedded competitionSectionProps={sectionProps} /> : null}
      {activeTab === "customFields" ? <CompetitionCustomFields {...sectionProps} /> : null}
      {activeTab === "scheduling" ? <CompetitionScheduling {...sectionProps} /> : null}
      {activeTab === "matchSheet" ? <GestionMatchSheetSettings /> : null}
    </Box>
  );
};

export default withUserContext(GestionSettings);
